export default function KpiTile({ label, value, sub, variant = 'default', accent }) {
  const classes = [
    'tg-kpi',
    variant === 'alert' ? 'tg-kpi--alert' : '',
    accent === 'teal' ? 'tg-kpi--accent-teal' : '',
    accent === 'success' ? 'tg-kpi--accent-success' : '',
    accent === 'warning' ? 'tg-kpi--accent-warning' : '',
  ].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      <div className="tg-kpi__label">{label}</div>
      <div className="tg-kpi__value">{value}</div>
      {sub && <div className="tg-kpi__sub">{sub}</div>}
    </div>
  )
}
